import { render, staticRenderFns } from "./Acquiring.vue?vue&type=template&id=3a03b9c5&scoped=true"
import script from "./Acquiring.vue?vue&type=script&lang=js"
export * from "./Acquiring.vue?vue&type=script&lang=js"
import style0 from "./Acquiring.vue?vue&type=style&index=0&id=3a03b9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a03b9c5",
  null
  
)

export default component.exports